import { axiosArisChatInstance } from "../AxiosConfiguration";

/**
 * The Research Dialogue Library (guide §13, WEB_INTEGRATION WP-W8) — aris-ai,
 * raw, no envelope. Both reads are version-pinned: pass the ids the Overview's
 * `view_the_research` handed over, never a fresh "latest", so the member sees
 * exactly the evidence their conversation was built from.
 *
 * A 404 is a refusal (the gates are closed, or no stored payload for that
 * version), not an error to retry.
 */

/**
 * `GET /ARIS/v4/research/dialogues/{id}?dialogue_id=&foundation_version=&library_version=`
 * → `{how_this_dialogue_is_informed, what_the_research_tells_us[], how_aris_uses_this_research,
 * research_and_sources[], material_limitations, about_our_research,
 * external_review_disclosure?, content_gaps[], …}`.
 */
export const getResearchDialogue = async (researchDialogueId, params = {}) => {
  const res = await axiosArisChatInstance.get(
    `/ARIS/v4/research/dialogues/${encodeURIComponent(researchDialogueId)}`,
    { params }
  );
  return res?.data ?? null;
};

/**
 * `GET /ARIS/v4/research/sources/{source_id}?dialogue_id=&library_version=` →
 * `{source_title, institution, publisher_key, evidence_type, published_reviewed,
 * why_aris_uses_this, what_this_supports, important_limitations, verified_url,
 * link_available, review_required}`.
 */
export const getResearchSource = async (sourceId, params = {}) => {
  const res = await axiosArisChatInstance.get(
    `/ARIS/v4/research/sources/${encodeURIComponent(sourceId)}`,
    { params }
  );
  return res?.data ?? null;
};
